// @flow

import Price from "common/records/Price"
import type { Baggage } from "mmb/common/types/baggageTypes"
import type { BaggagesInput } from "mmb/records/bookingInput"

export default function(baggages: BaggagesInput): Array<Baggage> {
  return (
    baggages &&
    baggages.confirmed.map(bagPerFlight => ({
      additionalBookingId: bagPerFlight.additional_booking_id,
      bid: bagPerFlight.booking_id,
      id: bagPerFlight.bag.id,
      flightFid: bagPerFlight.flight_fid,
      flightId: String(bagPerFlight.flight_id),
      index: bagPerFlight.index,
      pid: bagPerFlight.passenger_id,
      price: new Price({
        amount: bagPerFlight.price.amount,
        currency: bagPerFlight.price.currency,
      }),
      category: bagPerFlight.bag.category,
      bag: {
        category: bagPerFlight.bag.category,
        height: bagPerFlight.bag.height,
        length: bagPerFlight.bag.length,
        weight: bagPerFlight.bag.weight,
        width: bagPerFlight.bag.width,
      },
    }))
  )
}
